export default __webpack_public_path__ + "static/media/sfz.5b78c912.png";